import { Box, Button, Card, CardContent, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';

const MainInfoComponent = () => {
  return (
    <Container maxWidth="false" style={{ maxWidth: '1300px', marginTop: '70px' }} className="mb-3">
      <div className={`${styles.InfoDiv}`} id="whyFalcon">
        {/* <Grid container spacing={4}  className="mt-4 d-flex align-items-center">
        <Grid item md={3} xl={3} lg={3} sm={12} xs={12}>
         <div className={styles.iconContainer}>
          <img
            alt="arzooo-header-logo"
            className={styles.headerLogo}
            src="/images/icon1.svg"
          ></img>
        </div>
        </Grid>
        <Grid item md={3} xl={3} lg={3} sm={12} xs={12}>
         <div className={styles.rewardIconContainer}>
          <img
            alt="arzooo-header-logo"
            className={styles.headerLogo}
            src="/images/icon2.svg"
          ></img>
        </div>
        </Grid>
        <Grid item md={3} xl={3} lg={3} sm={12} xs={12}>
         <div className={styles.iconContainer}>
          <img
            alt="arzooo-header-logo"
            className={styles.headerLogo}
            src="/images/icon3.svg"
          ></img>
        </div>
        </Grid>
        <Grid item md={3} xl={3} lg={3} sm={12} xs={12}>
         <div className={styles.iconContainer}>
          <img
            alt="arzooo-header-logo"
            className={styles.headerLogo}
            src="/images/icon4.svg"
          ></img>
        </div>
        </Grid>
        </Grid> */}
        <Box className={styles.mainContent}>
          <Grid container spacing={5} className="d-flex align-items-start">
            <Grid item md={3} xl={3} lg={3} sm={12} xs={12} className={`${styles.divBorder}`}>
              <div className="d-flex  pb-3">
                <img
                  alt="arzooo-header-logo"
                  className={styles.iconContainer}
                  src="/images/icon1.svg"
                ></img>
              </div>
              <div className="flex-colum ">
                <h4 className={styles.featureMainText}>Zero Distribution Cost</h4>
                <p className={`${styles.featureText}`}>
                  Sellers can reduce the cost in system maintenance, Operations, Marketing,
                  analytics and logistics services.
                </p>
              </div>
            </Grid>
            <Grid item md={3} xl={3} lg={3} sm={12} xs={12} className={`${styles.divBorder}`}>
              <div className="d-flex  pb-3">
                <img
                  alt="arzooo-header-logo"
                  className={styles.iconContainer}
                  src="/images/icon2.svg"
                  style={{ width: '52px' }}
                ></img>
              </div>

              <div className="flex-colum ">
                <h4 className={styles.featureMainText}>Rewards</h4>
                <p className={`${styles.featureText}`}>
                  Get exciting rewards and incentives on achieving the targets. Submit the deals to
                  increase the order count.
                </p>
              </div>
            </Grid>
            <Grid item md={3} xl={3} lg={3} sm={12} xs={12} className={`${styles.divBorder}`}>
              <div className="d-flex   pb-3">
                <img
                  alt="arzooo-header-logo"
                  className={styles.iconContainer}
                  src="/images/icon3.svg"
                  style={{ width: '52px' }}
                ></img>
              </div>
              <div className="flex-colum ">
                <h4 className={styles.featureMainText}>Network</h4>
                <p className={`${styles.featureText}`}>
                  Get connected to the large network of retailers spread across India and sell the
                  wide range of products.
                </p>
              </div>
            </Grid>
            <Grid item md={3} xl={3} lg={3} sm={12} xs={12} className={`${styles.divBorder}`}>
              <div className="d-flex   pb-3">
                <img
                  alt="arzooo-header-logo"
                  className={styles.iconContainer}
                  src="/images/icon4.svg"
                ></img>
              </div>
              <div className="flex-colum ">
                <h4 className={styles.featureMainText}>Borderless Trade</h4>
                <p className={`${styles.featureText}`}>
                  {' '}
                  In House Logistics enables the sellers to extend their reach beyond borders and
                  hassle free pick ups .
                </p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </Container>
  );
};
export default MainInfoComponent;
